/*
 * eu-seller/app.js — the page: one product card on the left, the answer on
 * the right (checklist, labels, listing texts).
 *
 * The card is plain JSON (EuCompose.cardKey hashes it for the daily cap) and
 * lives in «My products» through the shared draft editor (__toolDraft): a
 * crash, F5 or a closed tab gives the card back.
 * Official texts are loaded per label language from public/data/eu-seller/.
 */
(function () {
    'use strict';

    var CFG = window.__EU_SELLER__ || {};
    var I = CFG.i18n || {};
    var SLUG = CFG.slug || 'eu-seller-label';
    var R, C, S, Lb;
    var $ = function (id) { return document.getElementById(id); };
    var root = $('es');
    if (!root) return;

    /* ── strings ─────────────────────────────────────────────────────────── */
    /* Ключ с точками: «field.epr.fr_idu» — в переводе это field → «epr.fr_idu» (ключ сам
       с точкой). Идём по частям, а не нашли часть — берём остаток пути целиком: без этого
       каждое «Заполните: …» в чек-листе печатало сырой ключ «field.mfr.name» (QA 23.10.2026). */
    function t(key, rep) {
        var parts = key.split('.'), v = I;
        for (var i = 0; i < parts.length && v != null; i++) {
            if (typeof v === 'object' && Object.prototype.hasOwnProperty.call(v, parts[i])) { v = v[parts[i]]; continue; }
            var rest = parts.slice(i).join('.');
            v = typeof v === 'object' ? v[rest] : undefined;
            break;
        }
        var s = typeof v === 'string' ? v : key;
        if (rep) for (var k in rep) s = s.split(':' + k).join(String(rep[k]));
        return s;
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
    function fmtDate(iso) {
        if (!iso) return '';
        try { return new Intl.DateTimeFormat(window.__intlLocale ? window.__intlLocale() : 'en', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(new Date(iso + 'T00:00:00Z')); }
        catch (_) { return iso; }
    }
    /* «Сегодня» — день человека (__localYmd), а не дата сервера в разметке: страница живёт в
       кэше, и вчерашнее «ждёт акта» могло бы стоять уже после даты. */
    function today() { return window.__localYmd ? window.__localYmd() : CFG.today; }
    function stage(name, extra) { try { if (window.__stage) window.__stage(name, extra); } catch (_) { /* telemetry never breaks the page */ } }
    /* feature_use — что человек делает (без названия товара, адресов и номеров) */
    function ae(action, extra) { try { if (window.__ae) window.__ae('feature_use', Object.assign({ slug: SLUG, action: action }, extra || {})); } catch (_) { /* optional */ } }
    /* отказ — почему не получилось (без содержимого карточки) */
    function diag(issue, extra) { try { if (window.__aeDiagnostic) window.__aeDiagnostic(Object.assign({ issue: 'eu_' + issue }, extra || {})); } catch (_) { /* optional */ } }

    /* ── the card ────────────────────────────────────────────────────────── */
    function blankCard() {
        return {
            v: 1, name: '', category: '', extras: {}, type: '', batch: '', serial: '', markets: [],
            mfr: { name: '', address: '', email: '', phone: '', country: 'outside' },
            rp: { role: 'authorised_representative', name: '', address: '', email: '' },
            textile: { fibres: [], animal: false }, toy: { under3: '', hazard: '', warnings: [], age: '' },
            battery: { shape: 'prism' }, cosmetics: {}, clp: { codes: [], pictos: [], codesText: '' },
            packaging: { parts: [], largestCm2: '' }, epr: {}, contact: '', ce: { nb: '' },
            usbc: { included: 'no', min: '', max: '', pd: false }, fcmSymbol: true,
            label: { kind: 'product', fmt: '', copies: '', caption: '', langs: null, roll: { w: 58, h: 40 } },
        };
    }
    var card = blankCard();

    function getPath(o, path) {
        var p = path.split('.');
        for (var i = 0; i < p.length; i++) { if (o == null) return undefined; o = o[p[i]]; }
        return o;
    }
    function setPath(o, path, v) {
        var p = path.split('.');
        for (var i = 0; i < p.length - 1; i++) { if (o[p[i]] == null || typeof o[p[i]] !== 'object') o[p[i]] = {}; o = o[p[i]]; }
        o[p[p.length - 1]] = v;
    }

    /* ── form ↔ card ─────────────────────────────────────────────────────── */
    function bindFields() {
        root.querySelectorAll('[data-k]').forEach(function (el) {
            var path = el.getAttribute('data-k');
            var ev = (el.type === 'checkbox' || el.tagName === 'SELECT') ? 'change' : 'input';
            el.addEventListener(ev, function () {
                var v = el.type === 'checkbox' ? el.checked : el.value;
                setPath(card, path, v);
                if (path === 'clp.codesText') parseClpCodes();
                changed(ev === 'change');
            });
        });
    }
    function paintFields() {
        root.querySelectorAll('[data-k]').forEach(function (el) {
            var v = getPath(card, el.getAttribute('data-k'));
            if (el.type === 'checkbox') el.checked = !!v;
            else el.value = v == null ? '' : v;
        });
        root.querySelectorAll('[data-cat]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cat') === card.category)); });
        paintMarkets();
        root.querySelectorAll('[data-toy-point]').forEach(function (cb) { cb.checked = (card.toy.warnings || []).indexOf(+cb.getAttribute('data-toy-point')) >= 0; });
        root.querySelectorAll('[data-picto]').forEach(function (cb) { cb.checked = (card.clp.pictos || []).indexOf(cb.getAttribute('data-picto')) >= 0; });
        paintFibres();
        paintParts();
        parseClpCodes();
        var cp = $('es-copies'); if (cp) cp.value = card.label.copies || '';
        var kd = $('es-kind'); if (kd) kd.querySelectorAll('[data-kind]').forEach(function (x) { var on = x.getAttribute('data-kind') === card.label.kind; x.classList.toggle('on', on); x.setAttribute('aria-pressed', String(on)); });
        if ($('es-roll-w')) { $('es-roll-w').value = (card.label.roll || {}).w || 58; $('es-roll-h').value = (card.label.roll || {}).h || 40; }
    }

    function paintMarkets() {
        root.querySelectorAll('[data-market]').forEach(function (b) {
            var on = card.markets.indexOf(b.getAttribute('data-market')) >= 0;
            b.classList.toggle('on', on);
            b.setAttribute('aria-pressed', String(on));
        });
    }

    /* Fibre rows: an Annex I name (by number; entry 2 by animal) and a percentage. */
    function fibreSelect(value) {
        var s = document.createElement('select');
        s.className = 'tc-in';
        s.setAttribute('aria-label', t('fibre'));
        (CFG.fibres || []).forEach(function (o) {
            var op = document.createElement('option');
            op.value = o.v; op.textContent = o.l;
            s.appendChild(op);
        });
        s.value = value;
        return s;
    }
    function paintFibres() {
        var host = $('es-fibres');
        if (!host) return;
        host.textContent = '';
        (card.textile.fibres || []).forEach(function (f, i) {
            var row = document.createElement('div');
            row.className = 'es-row';
            var sel = fibreSelect(+f.n === 2 ? '2:' + (f.sub | 0) : String(f.n));
            sel.addEventListener('change', function () {
                var v = sel.value.split(':');
                f.n = +v[0]; f.sub = v[1] != null ? +v[1] : undefined;
                changed(true);
            });
            var pct = document.createElement('input');
            pct.className = 'tc-in'; pct.inputMode = 'decimal'; pct.value = f.pct; pct.setAttribute('aria-label', I.tex_pct || '%');
            pct.addEventListener('input', function () { f.pct = parseFloat(String(pct.value).replace(',', '.')) || 0; paintFibreSum(); changed(false); });
            var x = document.createElement('button');
            x.type = 'button'; x.className = 'es-x'; x.textContent = '×'; x.setAttribute('aria-label', '×');
            x.addEventListener('click', function () { card.textile.fibres.splice(i, 1); paintFibres(); changed(true); });
            row.appendChild(sel); row.appendChild(pct); row.appendChild(x);
            host.appendChild(row);
        });
        paintFibreSum();
    }
    function paintFibreSum() {
        var el = $('es-fibre-sum');
        if (!el) return;
        var sum = R ? R.fibreSum(card) : 0;
        el.textContent = (card.textile.fibres || []).length ? t('tex_sum', { sum: Math.round(sum * 10) / 10 }) : '';
        el.classList.toggle('bad', Math.abs(sum - 100) > 0.01);
    }

    /* Packaging parts: what the part is (for the IT/ES/FR words) and its material code. */
    var PART_WORDS = {
        it: { box: 'Scatola', bag: 'Sacchetto', film: 'Film', filler: 'Carta di riempimento', bubble: 'Pluriball', jar: 'Barattolo', bottle: 'Bottiglia', lid: 'Tappo', tin: 'Scatola in metallo', tube: 'Tubetto', tray: 'Vassoio', envelope: 'Busta', label: 'Etichetta', tape: 'Nastro adesivo', pouch: 'Busta' },
        es: { box: 'Caja', bag: 'Bolsa', film: 'Film', filler: 'Papel de relleno', bubble: 'Plástico de burbujas', jar: 'Tarro', bottle: 'Botella', lid: 'Tapa', tin: 'Lata', tube: 'Tubo', tray: 'Bandeja', envelope: 'Sobre', label: 'Etiqueta', tape: 'Cinta adhesiva', pouch: 'Bolsa' },
        fr: { box: 'Boîte', bag: 'Sachet', film: 'Film', filler: 'Papier de calage', bubble: 'Papier bulle', jar: 'Pot', bottle: 'Bouteille', lid: 'Couvercle', tin: 'Boîte métal', tube: 'Tube', tray: 'Barquette', envelope: 'Enveloppe', label: 'Étiquette', tape: 'Ruban adhésif', pouch: 'Sachet' },
    };
    function paintParts() {
        var host = $('es-parts');
        if (!host) return;
        host.textContent = '';
        (card.packaging.parts || []).forEach(function (p, i) {
            var row = document.createElement('div');
            row.className = 'es-row pk';
            var kind = document.createElement('select');
            kind.className = 'tc-in'; kind.setAttribute('aria-label', I.pack_kind || 'Part');
            Object.keys(CFG.parts || {}).forEach(function (k) { var o = document.createElement('option'); o.value = k; o.textContent = CFG.parts[k]; kind.appendChild(o); });
            kind.value = p.kind || 'box';
            var mat = document.createElement('select');
            mat.className = 'tc-in'; mat.setAttribute('aria-label', I.pack_mat || 'Material');
            Object.keys(CFG.mats || {}).forEach(function (k) { var o = document.createElement('option'); o.value = k; o.textContent = CFG.mats[k] + ' — ' + (R ? R.packCode(k) : k); mat.appendChild(o); });
            mat.value = p.code || 'PAP20';
            var sync = function () { p.kind = kind.value; p.code = mat.value; partWords(p); changed(true); };
            kind.addEventListener('change', sync); mat.addEventListener('change', sync);
            var x = document.createElement('button');
            x.type = 'button'; x.className = 'es-x'; x.textContent = '×'; x.setAttribute('aria-label', '×');
            x.addEventListener('click', function () { card.packaging.parts.splice(i, 1); paintParts(); changed(true); });
            row.appendChild(kind); row.appendChild(mat); row.appendChild(x);
            host.appendChild(row);
        });
    }
    function partWords(p) {
        p.name = (CFG.parts || {})[p.kind] || p.kind;
        p.name_it = PART_WORDS.it[p.kind]; p.name_es = PART_WORDS.es[p.kind]; p.name_fr = PART_WORDS.fr[p.kind];
        // French lines use the French word: the sorting block is printed in French.
        p.nameFr = p.name_fr;
    }

    function parseClpCodes() {
        var known = CFG.clpCodes || [];
        var raw = String(card.clp.codesText || '').toUpperCase().replace(/\s*\+\s*/g, '+').split(/[\s,;]+/).filter(Boolean);
        var ok = [], bad = [];
        raw.forEach(function (c) { if (known.indexOf(c) >= 0) { if (ok.indexOf(c) < 0) ok.push(c); } else bad.push(c); });
        card.clp.codes = ok;
        var el = $('es-clp-unknown');
        if (el) { el.hidden = !bad.length; el.textContent = bad.length ? t('clp_unknown', { codes: bad.join(', ') }) : ''; }
    }

    /* EPR numbers: one field per market for its packaging number (/epr-check
     * registry names it), plus the three numbers with a printed place. */
    function paintEpr() {
        var host = $('es-epr');
        if (!host) return;
        var want = [];
        if (card.markets.indexOf('fr') >= 0) want.push(['fr_idu', I.epr_fr_idu]);
        if (card.markets.indexOf('de') >= 0) want.push(['de_lucid', I.epr_de_lucid]);
        var F = R.facts(card);
        if (card.markets.indexOf('de') >= 0 && F.isEEE) want.push(['de_weee', I.epr_de_weee]);
        card.markets.forEach(function (m) {
            if (m === 'fr' || m === 'de' || m === 'xi') return;
            var nm = (CFG.eprNames || {})[m];
            if (!nm) return;
            want.push([m + '_pack', t('epr_other', { country: (CFG.countries || {})[m] || m.toUpperCase(), name: nm })]);
        });
        var sig = want.map(function (w) { return w[0]; }).join(',');
        if (host.getAttribute('data-sig') === sig) return;
        host.setAttribute('data-sig', sig);
        host.textContent = '';
        want.forEach(function (w) {
            var lab = document.createElement('label');
            lab.className = 'tc-f';
            lab.innerHTML = '<span class="tc-f-l">' + esc(w[1]) + '</span>';
            var inp = document.createElement('input');
            inp.className = 'tc-in'; inp.autocomplete = 'off'; inp.spellcheck = false;
            inp.value = (card.epr || {})[w[0]] || '';
            inp.addEventListener('input', function () { card.epr[w[0]] = inp.value; changed(false); });
            lab.appendChild(inp);
            host.appendChild(lab);
        });
    }

    /* Sections that only some products have. */
    function paintVisibility(ev) {
        var F = ev.facts;
        var show = { textile: F.isTextile, toy: F.isToy, battery: F.hasBattery, cosmetics: F.isCosmetic, candle: F.isClp, radio: F.radio, kitchen: F.isFoodContact };
        root.querySelectorAll('details[data-for]').forEach(function (d) {
            var on = !!show[d.getAttribute('data-for')];
            if (d.hidden === on) { d.hidden = !on; if (on) d.open = true; }
        });
        var rp = $('es-p-rp'); if (rp) rp.hidden = F.mfrInEU;
        var ch = $('es-cat-hint'); if (ch) ch.hidden = card.category !== ch.getAttribute('data-cat-hint');
        var nb = $('es-nb-wrap'); if (nb) nb.hidden = !F.ce;
        var cyl = card.battery && card.battery.shape === 'cylinder';
        root.querySelectorAll('[data-shape]').forEach(function (el) { el.hidden = el.getAttribute('data-shape') !== (cyl ? 'cylinder' : 'prism'); });
    }

    /* ── official texts, per language ────────────────────────────────────── */
    var TEXTS = {};
    var pendingTexts = {};
    function loadTexts(langs) {
        var need = langs.filter(function (l) { return !TEXTS[l] && !pendingTexts[l]; });
        return Promise.all(langs.map(function (l) {
            if (TEXTS[l]) return TEXTS[l];
            if (!pendingTexts[l]) {
                pendingTexts[l] = fetch(CFG.textsBase + l + '.json' + (CFG.textsVer ? '?v=' + CFG.textsVer : ''), { credentials: 'same-origin' })
                    .then(function (r) { if (!r.ok) throw new Error('texts ' + l + ' ' + r.status); return r.json(); })
                    .then(function (j) { TEXTS[l] = j; return j; })
                    .catch(function (e) { delete pendingTexts[l]; throw e; });
            }
            return pendingTexts[l];
        })).then(function () { return need.length > 0; });
    }

    /* ── checklist ───────────────────────────────────────────────────────── */
    function paintAnswer(ev) {
        var n = ev.markets.length;
        var c = ev.counts;
        $('es-ans-l').textContent = n ? t('ans_label', { n: n }) : (I.ans_none || '');
        var v = $('es-ans-v');
        v.textContent = !n ? '—' : (c.todo ? t('ans_todo', { n: c.todo }) : t('ans_ready'));
        v.classList.toggle('es-todo', !!(n && c.todo));
        var lv = $('es-live'), lvv = $('es-live-v');
        if (lv) {
            lv.hidden = !n;
            lvv.textContent = n ? v.textContent + ' · ' + t('count_now_n', { n: c.now }) : '';
            lvv.classList.toggle('todo', !!c.todo);
        }
        $('es-ans-counts').innerHTML = !n ? '' : [
            ['now', c.now, t('count_now')], ['todo', c.todo, t('count_todo')],
            ['soon', c.soon, t('count_soon')], ['pending', c.pending, t('count_pending')],
        ].filter(function (r) { return r[1]; }).map(function (r) {
            return '<span class="es-count ' + r[0] + '"><b>' + r[1] + '</b>' + esc(r[2]) + '</span>';
        }).join('');
    }
    function paintChecklist(ev) {
        var host = $('es-check');
        if (!ev.markets.length) { host.innerHTML = '<p class="tc-hint">' + esc(t('no_items')) + '</p>'; return; }
        host.innerHTML = ev.items.map(function (it) {
            var rule = (CFG.rules || {})[it.id] || {};
            var tag;
            if (it.status === 'now') tag = it.missing.length ? '<span class="es-tag todo">' + esc(t('st_todo')) + '</span>' : '<span class="es-tag now">' + esc(it.since ? t('since', { date: fmtDate(it.since) }) : t('st_now')) + '</span>';
            else if (it.status === 'soon') tag = '<span class="es-tag soon">' + esc(t('st_soon', { date: fmtDate(it.since) })) + '</span>';
            else tag = '<span class="es-tag pending">' + esc(t('st_pending', { date: fmtDate(it.since) })) + '</span>';
            var country = it.country ? '<span class="es-tag">' + esc((CFG.countries || {})[it.country] || it.country.toUpperCase()) + '</span>' : '';
            var where = it.where.map(function (w) { return t('w_' + w); }).join(' · ');
            var miss = it.missing.length ? '<div class="es-miss">' + esc(t('missing', { fields: '' })) + it.missing.map(function (f) {
                return '<button type="button" data-goto="' + esc(f) + '">' + esc(t('field.' + f)) + '</button>';
            }).join(', ') + '</div>' : '';
            var link = it.link === 'epr-check' ? ' <a href="' + esc(CFG.eprUrl) + '">' + esc(t('open_epr')) + '</a>' : '';
            var cls = 'es-item' + (it.id === 'ce_forbidden' ? ' no' : '') + (it.status === 'now' && it.missing.length ? ' todo' : '');
            return '<div class="' + cls + '" data-rule="' + esc(it.id) + '"><div class="es-item-h"><b>' + esc(rule.t || it.id) + '</b>' + tag + country + '</div>'
                + '<p>' + esc(rule.d || '') + link + '</p>'
                + '<div class="es-law">' + esc(t('where')) + ': ' + esc(where) + ' · ' + esc(it.law) + '</div>' + miss + '</div>';
        }).join('');
    }

    /* Чек-лист текстом — отправить подрядчику, представителю в ЕС или в свою таблицу дел. */
    function checklistText() {
        var ev = R.evaluate(card, today());
        if (!ev.markets.length) return '';
        var head = (card.name ? card.name + ' — ' : '') + ev.markets.map(function (m) { return (CFG.countries || {})[m] || m.toUpperCase(); }).join(', ');
        var lines = ev.items.map(function (it) {
            var rule = (CFG.rules || {})[it.id] || {};
            var st = it.status === 'now' ? (it.missing.length ? t('st_todo') : (it.since ? t('since', { date: fmtDate(it.since) }) : t('st_now')))
                : it.status === 'soon' ? t('st_soon', { date: fmtDate(it.since) }) : t('st_pending', { date: fmtDate(it.since) });
            var row = '• ' + (rule.t || it.id) + ' — ' + st + (it.country ? ' (' + ((CFG.countries || {})[it.country] || it.country.toUpperCase()) + ')' : '');
            if (rule.d) row += '\n  ' + rule.d;
            row += '\n  ' + it.law;
            if (it.missing.length) row += '\n  ' + t('missing', { fields: '' }) + it.missing.map(function (f) { return t('field.' + f); }).join(', ');
            return row;
        });
        return head + '\n\n' + lines.join('\n\n') + '\n\n' + location.origin + location.pathname;
    }

    /* «Fill in: manufacturer address» jumps to the field. */
    var GOTO = {
        'mfr.name': '[data-k="mfr.name"]', 'mfr.address': '[data-k="mfr.address"]', 'mfr.email': '[data-k="mfr.email"]',
        'rp.name': '[data-k="rp.name"]', 'rp.address': '[data-k="rp.address"]', 'rp.email': '[data-k="rp.email"]',
        'id': '[data-k="type"]', 'textile.fibres': '#es-fibre-add', 'toy.warnings': '[data-k="toy.under3"]',
        'cos.content': '[data-k="cosmetics.content"]', 'cos.inci': '[data-k="cosmetics.inci"]', 'cos.durability': '[data-k="cosmetics.pao"]',
        'clp.codes': '[data-k="clp.codesText"]', 'clp.phone': '[data-k="mfr.phone"]', 'pack.parts': '#es-part-add',
        'epr.fr_idu': '#es-epr', 'epr.de_lucid': '#es-epr', 'epr.de_weee': '#es-epr', 'usbc.power': '[data-k="usbc.max"]',
    };
    function gotoField(key) {
        var el = root.querySelector(GOTO[key] || '');
        if (!el) return;
        var d = el.closest('details'); if (d) d.open = true;
        if (el.id === 'es-epr') el = el.querySelector('input') || el;
        el.scrollIntoView({ block: 'nearest' });
        try { el.focus({ preventScroll: true }); } catch (_) { el.focus(); }
    }

    /* ── labels ──────────────────────────────────────────────────────────── */
    var labelTimer = 0;
    var lastLay = null;
    var lastVerdictSig = '';
    var paintSeq = 0;
    function currentFormat() {
        var id = card.label.fmt || defaultFormat(card.label.kind);
        return Lb.formatById(id, card.label.roll) || Lb.formatById(defaultFormat(card.label.kind));
    }
    function defaultFormat(kind) {
        return { product: 'div-24', pack: 'div-8', insert: 'div-4' }[kind] || 'div-24';
    }
    function paintFormats() {
        var sel = $('es-format');
        var cur = card.label.fmt || defaultFormat(card.label.kind);
        if (sel.getAttribute('data-built') !== '1') {
            sel.textContent = '';
            var g1 = document.createElement('optgroup'); g1.label = I.printer_sheet || 'Sheets';
            Lb.sheetFormats().forEach(function (f) { var o = document.createElement('option'); o.value = f.id; o.textContent = Lb.formatLabel(f); g1.appendChild(o); });
            var g2 = document.createElement('optgroup'); g2.label = I.printer_roll || 'Roll';
            Lb.rollFormats().forEach(function (f) { var o = document.createElement('option'); o.value = f.id; o.textContent = Lb.formatLabel(f); g2.appendChild(o); });
            var oc = document.createElement('option'); oc.value = 'roll-custom'; oc.textContent = I.roll_custom || '…'; g2.appendChild(oc);
            sel.appendChild(g1); sel.appendChild(g2);
            sel.setAttribute('data-built', '1');
        }
        sel.value = cur;
        $('es-roll-custom').hidden = cur !== 'roll-custom';
        $('es-test').hidden = !Lb.isRoll(currentFormat());
    }
    function labelLangs(ev) {
        var auto = ev.languages;
        var on = Array.isArray(card.label.langs) ? card.label.langs.filter(function (l) { return auto.indexOf(l) >= 0; }) : auto.slice();
        return { auto: auto, on: on };
    }
    function paintLangs(ev) {
        var L = labelLangs(ev);
        var host = $('es-langs');
        host.innerHTML = L.auto.length ? L.auto.map(function (l) {
            var on = L.on.indexOf(l) >= 0;
            return '<button type="button" class="tc-chip' + (on ? ' on' : '') + '" data-lang="' + l + '" aria-pressed="' + on + '">' + l + '</button>';
        }).join('') : '<span class="tc-hint">' + esc(t('langs_none')) + '</span>';
        var cap = $('es-caption');
        var want = ['en'].concat(L.auto.filter(function (l) { return l !== 'en'; }));
        var sig = want.join(',');
        if (cap.getAttribute('data-sig') !== sig) {
            cap.innerHTML = want.map(function (l) { return '<option value="' + l + '">' + l.toUpperCase() + '</option>'; }).join('');
            cap.setAttribute('data-sig', sig);
        }
        cap.value = want.indexOf(card.label.caption) >= 0 ? card.label.caption : 'en';
    }

    function contentFor(c, kind, fmt, langs, caption) {
        var ev = R.evaluate(c, today());
        var blocks = C.blocks(c, kind, { texts: TEXTS, langs: langs, caption: caption, today: today(), i18n: { insert_title: (CFG.insertTitles || {})[caption] || (CFG.insertTitles || {}).en, contact: (CFG.contactCaptions || {})[caption] || (CFG.contactCaptions || {}).en } });
        var area = parseFloat(String((c.packaging || {}).largestCm2 || '').replace(',', '.'));
        var xh = S.xHeightRule(kind === 'product' ? null : (isFinite(area) ? area : null));
        var cap = parseFloat(String((c.clp || {}).capacityL || '').replace(',', '.'));
        var lay = Lb.layout(blocks, fmt, { xh: xh, capacityL: isFinite(cap) ? cap : 0.5 });
        lay.ev = ev; lay.xh = xh; lay.blocks = blocks;
        return lay;
    }

    function paintLabels() {
        clearTimeout(labelTimer);
        labelTimer = setTimeout(paintLabelsNow, 120);
    }
    function paintLabelsNow() {
        var pane = root.querySelector('[data-pane="labels"]');
        if (!pane || pane.hidden) return;
        var ev = R.evaluate(card, today());
        paintFormats();
        paintLangs(ev);
        var L = labelLangs(ev);
        var langs = L.on.length ? L.on : ['en'];
        var caption = card.label.caption || 'en';
        // Тексты языка ещё едут по сети — превью и вердикты не должны показывать прошлую карточку
        // («Заполните карточку» на медленной сети, QA 23.10.2026); отрисовывает только последний вызов.
        var seq = ++paintSeq;
        var wait = langs.concat([caption, 'en']).some(function (l) { return !TEXTS[l]; });
        if (wait) { $('es-one').classList.add('es-busy'); $('es-verdicts').innerHTML = '<div class="es-v">' + esc(I.preparing || '…') + '</div>'; }
        loadTexts(langs.concat([caption, 'en'])).then(function () {
            if (seq !== paintSeq) return;
            $('es-one').classList.remove('es-busy');
            var fmt = currentFormat();
            paintCopies(fmt);
            var lay = contentFor(card, card.label.kind, fmt, langs, caption);
            lastLay = { key: C.cardKey(card) + '|' + card.label.kind + '|' + fmt.id + '|' + langs.join(','), lay: lay };
            Lb.renderOne($('es-one'), fmt, lay);
            $('es-one-cap').textContent = Lb.formatLabel(fmt);
            paintVerdicts(lay, fmt, R.evaluate(card, today()), langs);
        }).catch(function (e) {
            if (seq === paintSeq) $('es-one').classList.remove('es-busy');
            diag('texts_load', { langs: langs.join(',') });
            if (window.__handleError) window.__handleError(e, 'eu_seller_texts', { say: t('export_fail') });
        });
    }

    function paintVerdicts(lay, fmt, ev, langs) {
        var out = [];
        var st = lay.stack;
        var hasText = st.elements.length > 0;
        if (!hasText && !lay.symbols.length) out.push(['warn', t('empty_label')]);
        else if (st.fits) out.push(['good', t('fit_ok', { size: round1(st.size), xh: round2(S.xHeight(st.size)), rule: num(lay.xh, 1) })]);
        else {
            out.push(['bad', t('fit_bad', { mm: round1(st.overflowMm) })]);
            var better = smallestFitting(fmt, langs);
            if (better) out.push(['fix', t('fit_try', { size: Lb.formatLabel(better) }), better.id]);
        }
        if (st.dropped && st.dropped.length) out.push(['bad', t('fit_drop', { list: st.dropped.map(function (id) { return t('name_' + id); }).join(', ') })]);
        if (!ev.facts.ce) out.push(['warn', t('ce_off', { cat: (I.cat_names || {})[ev.facts.cat] || ev.facts.cat })]);
        lay.symbols.forEach(function (s) {
            var ctx = { battery: card.battery, onPackaging: card.label.kind !== 'product', capacityL: parseFloat(card.clp.capacityL) || 0.5, labelW: fmt.w, labelH: fmt.h };
            var v = S.check(s.id, s.h, ctx);
            if (!v || (!S.SYMBOLS[s.id].rule && v.ok)) return; // a mark the law gives no size: nothing to report
            var name = t('name_' + s.id);
            if (v.code === 'triman_compact') out.push(['warn', t('sym_compact', { h: round1(s.h) })]);
            else if (v.code === 'battery_pack') out.push([v.ok ? 'warn' : 'bad', t('sym_battery_pack')]);
            else if (v.code === 'battery_dims') out.push(['warn', t('sym_battery_dims')]);
            else if (!v.ok) out.push(['bad', t('sym_bad', { name: name, h: round1(s.h), need: round1(v.need) })]);
            else out.push(['good', t('sym_ok', { name: name, h: round1(s.h) })]);
        });
        var blanks = (card.clp && card.clp.codes || []).filter(function (code) {
            var T = TEXTS.en && TEXTS.en.clp; var kind = /^EUH/.test(code) ? 'EUH' : code.charAt(0);
            var s = T && T[kind] && T[kind][code];
            return s && /…/.test(s) && code !== 'EUH208';
        });
        if (ev.facts.isClp && blanks.length) out.push(['warn', t('clp_blank', { codes: blanks.join(', ') })]);
        var missing = langs.filter(function (l) { return !TEXTS[l]; });
        if (missing.length) out.push(['warn', t('missing_lang', { langs: missing.join(', ').toUpperCase() })]);
        var sig = (st.fits ? 'fit' : 'nofit:' + fmt.id) + '|' + missing.join(',');
        if (sig !== lastVerdictSig) {
            lastVerdictSig = sig;
            if (!st.fits) diag('no_fit', { fmt: fmt.id, kind: card.label.kind, over_mm: Math.round(st.overflowMm || 0), langs: langs.length, fix: out.some(function (v) { return v[0] === 'fix'; }) ? 1 : 0 });
            if (missing.length) diag('missing_lang', { langs: missing.join(',') });
        }
        $('es-verdicts').innerHTML = out.map(function (v) {
            if (v[0] === 'fix') return '<div class="es-v warn"><button type="button" class="tc-btn sm" data-use-format="' + esc(v[2]) + '">' + esc(v[1]) + '</button></div>';
            return '<div class="es-v ' + v[0] + '">' + esc(v[1]) + '</div>';
        }).join('');
    }
    /* The smallest label of the same kind of stock (sheet or roll) that holds
       everything at a legible size — so «does not fit» comes with a way out. */
    function smallestFitting(fmt, langs) {
        var pool = (Lb.isRoll(fmt) ? Lb.rollFormats() : Lb.sheetFormats().filter(function (f) { return f.page === fmt.page; }))
            .filter(function (f) { return f.w * f.h > fmt.w * fmt.h; })
            .sort(function (a, b) { return a.w * a.h - b.w * b.h; });
        for (var i = 0; i < pool.length && i < 40; i++) {
            var lay = contentFor(card, card.label.kind, pool[i], langs, card.label.caption || 'en');
            if (lay.stack.fits && !lay.stack.dropped.length) return pool[i];
        }
        return null;
    }
    function num(v, d) {
        try { return new Intl.NumberFormat(window.__intlLocale ? window.__intlLocale() : 'en', { maximumFractionDigits: d, minimumFractionDigits: 0 }).format(v); }
        catch (_) { return String(Math.round(v * Math.pow(10, d)) / Math.pow(10, d)); }
    }
    function round1(v) { return num(v, 1); }
    function round2(v) { return num(v, 2); }

    /* ── export ──────────────────────────────────────────────────────────── */
    function busy(btn, on) {
        if (!btn) return;
        if (on) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; btn.__html = btn.innerHTML; btn.textContent = I.preparing || '…'; }
        else { btn.removeAttribute('aria-busy'); btn.disabled = false; if (btn.__html) btn.innerHTML = btn.__html; }
    }
    function deliver(blob, name) {
        return Promise.resolve(window.__downloadFile ? window.__downloadFile(blob, name) : false).then(function (r) { return r !== false; });
    }
    function fileName(c, kind, ext) {
        var base = String(c.name || 'product').trim() || 'product';
        var nm = window.__outputName ? window.__outputName.sanitize(base) : base.replace(/[\\/:*?"<>|]+/g, '_');
        return nm + ' — ' + kind + '.' + ext;
    }
    /* Empty «Copies» = the whole sheet (a roll prints one). */
    function copiesOf(fmt) {
        var raw = String($('es-copies').value || '').trim();
        var n = parseInt(raw, 10);
        if (!raw || !isFinite(n) || n < 1) n = Lb.isRoll(fmt) ? 1 : window.LabelSheets.perSheet(fmt);
        return Math.min(n, 2000);
    }
    function paintCopies(fmt) {
        var el = $('es-copies');
        el.placeholder = String(Lb.isRoll(fmt) ? 1 : window.LabelSheets.perSheet(fmt));
    }

    function exportOne() {
        var btn = $('es-pdf');
        if (btn.getAttribute('aria-busy') === 'true') return;
        if (lastLay && lastLay.lay && !lastLay.lay.stack.fits) {
            if (window.__toast) window.__toast(t('fit_block'), 'warning');
            diag('export_blocked_no_fit', { kind: card.label.kind });
            return;
        }
        var key = C.cardKey(card);
        var run = window.__toolLimit ? window.__toolLimit.begin(SLUG, [key]) : { commit: function () {}, abort: function () {} };
        if (!run) return;
        busy(btn, true);
        stage('exporting', { kind: card.label.kind });
        var ev = R.evaluate(card, today());
        var L = labelLangs(ev);
        var langs = L.on.length ? L.on : ['en'];
        var caption = card.label.caption || 'en';
        var fmt = currentFormat();
        loadTexts(langs.concat([caption, 'en'])).then(function () {
            fmt = currentFormat();
            var lay = contentFor(card, card.label.kind, fmt, langs, caption);
            if (!lay.stack.fits) { var nf = new Error('label does not fit'); nf.nofit = true; throw nf; }
            var n = copiesOf(fmt);
            var cells = []; for (var i = 0; i < n; i++) cells.push({ items: lay.items, symbols: lay.symbols });
            return Lb.pdf({ fmt: fmt, cells: cells, title: (card.name || '') + ' — ' + card.label.kind, lang: langs[0], rulerCaption: '50 mm' });
        }).then(function (res) {
            return deliver(res.blob, fileName(card, card.label.kind, 'pdf'));
        }).then(function (ok) {
            if (!ok) { run.abort(); return; }
            run.commit();
            if (drafts) try { drafts.exported(); } catch (_) { /* list state only */ }
            stage('exported', { kind: card.label.kind, fmt: fmt.id, langs: (labelLangs(R.evaluate(card, today())).on || []).length });
            if (window.__aeToolComplete) try { window.__aeToolComplete(); } catch (_) { /* telemetry */ }
        }).catch(function (e) {
            run.abort();
            if (e && e.nofit) { if (window.__toast) window.__toast(t('fit_block'), 'warning'); return; }
            stage('error', { reason: String((e && e.message) || e).slice(0, 120) });
            if (window.__handleError) window.__handleError(e, 'eu_seller_pdf', { say: t('export_fail') });
        }).then(function () { busy(btn, false); });
    }

    function exportTest() {
        var fmt = currentFormat();
        if (!Lb.isRoll(fmt)) return;
        window.LabelPdf.buildTestPage(fmt, { dpi: 203, caption: Lb.formatLabel(fmt), rulerCaption: '50 mm' })
            .then(function (res) { ae('test_label', { fmt: fmt.id }); return deliver(res.blob, 'test-label-' + fmt.w + 'x' + fmt.h + '.pdf'); })
            .catch(function (e) { if (window.__handleError) window.__handleError(e, 'eu_seller_test', { say: t('export_fail') }); });
    }

    function exportSvg() {
        var ev = R.evaluate(card, today());
        var ids = ev.symbols.on.slice();
        if (ev.facts.isFoodContact) ids.push('fcm');
        if (ev.facts.radio) ids.push((card.usbc || {}).included === 'yes' ? 'usbcIn' : 'usbcOut');
        if (!ids.length) ids = ['triman', 'weeeBar', 'battery'];
        var svg = Lb.symbolsSvg(ids, { colour: '#ffd400' });
        deliver(new Blob([svg], { type: 'image/svg+xml' }), fileName(card, 'symbols', 'svg'));
        ae('svg', { n: ids.length });
    }

    /* ── CSV: many products, one PDF ─────────────────────────────────────── */
    var csvCards = [];
    function fibreFromWord(word) {
        var w = String(word || '').toLowerCase().trim();
        if (!w) return null;
        var hit = null;
        (CFG.fibres || []).some(function (o) {
            var names = o.l.toLowerCase().split(' — ');
            if (names.some(function (n) { return n === w || n.split(/[ ,()]+/).indexOf(w) >= 0; })) { hit = o.v; return true; }
            return false;
        });
        if (!hit) return null;
        var v = hit.split(':');
        return { n: +v[0], sub: v[1] != null ? +v[1] : undefined };
    }
    function parseCsv(text) {
        var tbl = window.LabelData.parseTable(text, {});
        var out = [], errors = [];
        (tbl.rows || []).forEach(function (row, i) {
            var get = function (k) { var keys = Object.keys(row); for (var j = 0; j < keys.length; j++) if (keys[j].toLowerCase().trim() === k) return String(row[keys[j]] || '').trim(); return ''; };
            var c = JSON.parse(JSON.stringify(card));
            ['name', 'type', 'batch', 'serial'].forEach(function (k) { var v = get(k); if (v) c[k] = v; });
            var cat = get('category'); if (cat && R.CATEGORIES.indexOf(cat) >= 0) c.category = cat;
            // колонка — «fibres» или «fibers»: подсказка en пишет её по-американски, остальные — как было
            var fib = get('fibres') || get('fibers');
            if (fib) {
                c.textile = c.textile || {};
                c.textile.fibres = [];
                // «cotton 60 + polyester 40»: «+» is safe inside any CSV; «;», «|» and «,» work when quoted.
                fib.split(/[;|+,]/).forEach(function (part) {
                    var m = part.trim().match(/^(.+?)\s+(\d+(?:[.,]\d+)?)\s*%?$/) || part.trim().match(/^(\d+(?:[.,]\d+)?)\s*%?\s+(.+)$/);
                    if (!m) return;
                    var name = isNaN(parseFloat(m[1])) ? m[1] : m[2];
                    var pct = parseFloat(String(isNaN(parseFloat(m[1])) ? m[2] : m[1]).replace(',', '.'));
                    var f = fibreFromWord(name);
                    if (!f) { errors.push(t('csv_bad', { row: i + 2, why: t('fibre_unknown', { name: name }) })); return; }
                    f.pct = pct;
                    c.textile.fibres.push(f);
                });
                var sum = R.fibreSum(c);
                if (c.textile.fibres.length && Math.abs(sum - 100) > 0.01) {
                    // A composition that is not 100 % is not printed: the row is left out and named.
                    errors.push(t('csv_bad', { row: i + 2, why: t('csv_sum', { sum: num(sum, 1) }) }));
                    return;
                }
            }
            if (!c.name && !c.type && !c.batch) return;
            out.push(c);
        });
        return { cards: out, errors: errors };
    }
    function onCsvFile(file) {
        var read = window.SubtitleParser && window.SubtitleParser.readFile ? window.SubtitleParser.readFile(file).then(function (o) { return o.text; }) : file.text();
        read.then(function (text) {
            var r = parseCsv(text);
            csvCards = r.cards;
            ae('csv_loaded', { n: csvCards.length, bad: r.errors.length });
            if (!csvCards.length || r.errors.length) diag('csv_rows', { ok: csvCards.length, bad: r.errors.length });
            $('es-csv-status').textContent = [t('csv_loaded', { n: csvCards.length })].concat(r.errors.slice(0, 5)).join(' · ');
            $('es-csv-go').disabled = !csvCards.length;
        }).catch(function (e) { if (window.__handleError) window.__handleError(e, 'eu_seller_csv', { say: t('export_fail') }); });
    }
    function exportCsv() {
        var btn = $('es-csv-go');
        if (!csvCards.length || btn.getAttribute('aria-busy') === 'true') return;
        var keys = csvCards.map(function (c) { return C.cardKey(c); });
        var run = window.__toolLimit ? window.__toolLimit.begin(SLUG, keys) : { commit: function () {}, abort: function () {} };
        if (!run) return;
        busy(btn, true);
        var ev = R.evaluate(card, today());
        var L = labelLangs(ev);
        var langs = L.on.length ? L.on : ['en'];
        var caption = card.label.caption || 'en';
        loadTexts(langs.concat([caption, 'en'])).then(function () {
            var fmt = currentFormat();
            var n = copiesOf(fmt);
            var cells = [];
            csvCards.forEach(function (c) {
                var lay = contentFor(c, card.label.kind, fmt, langs, caption);
                for (var i = 0; i < n; i++) cells.push({ items: lay.items, symbols: lay.symbols });
            });
            return Lb.pdf({ fmt: fmt, cells: cells, title: card.label.kind, lang: langs[0] });
        }).then(function (res) {
            return deliver(res.blob, 'eu-labels-' + csvCards.length + '.pdf');
        }).then(function (ok) {
            if (!ok) { run.abort(); return; }
            run.commit();
            stage('exported', { kind: 'csv', n: csvCards.length });
            if (window.__aeToolComplete) try { window.__aeToolComplete({ csv: 1, n: csvCards.length }); } catch (_) { /* telemetry */ }
        }).catch(function (e) {
            run.abort();
            if (window.__handleError) window.__handleError(e, 'eu_seller_csv_pdf', { say: t('export_fail') });
        }).then(function () { busy(btn, false); });
    }

    /* ── listing texts ───────────────────────────────────────────────────── */
    function paintTexts() {
        var pane = root.querySelector('[data-pane="texts"]');
        if (!pane || pane.hidden) return;
        var ev = R.evaluate(card, today());
        var langs = labelLangs(ev).on;
        loadTexts(langs.concat(['en'])).then(function () {
            var x = C.listing(card, { texts: TEXTS, langs: langs, caption: card.label.caption || 'en', today: today() });
            // The fibre composition is its own field on the marketplaces, not a warning.
            var fib = ev.facts.isTextile ? C.fibreLines(card, TEXTS, langs) : [];
            var warn = x.safety.filter(function (l) { return fib.indexOf(l) < 0; });
            var blocks = [
                [I.tx_mfr, x.manufacturer],
                [I.tx_rp, x.rp],
                [I.tx_id, x.identification],
                [I.tx_safety, warn.join('\n')],
                [I.tx_legal, x.legal.length ? x.legal.join('\n') : ''],
            ];
            if (fib.length) blocks.splice(3, 0, [((CFG.rules || {}).tex_fibres || {}).t || 'Fibres', fib.join('\n')]);
            $('es-texts').innerHTML = blocks.map(function (b, i) {
                var empty = !String(b[1] || '').trim();
                return '<div class="es-tx"><div class="es-tx-h"><b>' + esc(b[0]) + '</b>'
                    + (empty ? '' : '<button type="button" class="tc-btn sm ghost" data-copy="' + i + '">' + esc(I.tx_copy) + '</button>') + '</div>'
                    + '<pre>' + esc(empty ? (b[0] === I.tx_legal ? I.tx_legal_empty : '—') : b[1]) + '</pre></div>';
            }).join('');
            $('es-texts').__blocks = blocks;
        });
    }
    function copyText(i) {
        var b = ($('es-texts').__blocks || [])[i];
        if (!b) return;
        var done = function (ok) {
            if (window.__toast) window.__toast(ok ? (I.tx_copied || 'Copied') : (I.copy_fail || I.export_fail || '—'), ok ? 'success' : 'error');
            if (ok) ae('copy_text', { block: ['mfr', 'rp', 'id', 'safety', 'legal', 'fibres'][i] || String(i) });
        };
        if (window.__copyText) window.__copyText(b[1]).then(done, function () { done(false); });
        else if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(b[1]).then(function () { done(true); }, function () { done(false); });
        else done(false);
    }

    /* ── render loop ─────────────────────────────────────────────────────── */
    var drafts = null;
    var firstResult = false;
    function changed(final) {
        render();
        if (drafts) try { drafts.touch(!!final); } catch (_) { /* saving is best-effort */ }
    }
    function render() {
        var ev = R.evaluate(card, today());
        paintVisibility(ev);
        paintEpr();
        paintAnswer(ev);
        paintChecklist(ev);
        paintLabels();
        paintTexts();
        if (ev.markets.length && !firstResult) { firstResult = true; stage('result'); }
    }

    /* Вкладки. На широкой консоли (≥ 1480 px, класс es-wide) чек-лист стоит всегда, а вкладки
       решают, что рядом с ним: этикетки или тексты — «карточка · чек-лист · этикетка» видны
       сразу (QA 23.10.2026: на 1920 было две колонки и вкладка за вкладкой). */
    var curTab = 'check';
    function applyTabs() {
        var wide = root.classList.contains('es-wide');
        var name = wide && curTab === 'check' ? 'labels' : curTab;
        root.querySelectorAll('[data-tab]').forEach(function (b) {
            var tab = b.getAttribute('data-tab');
            var on = tab === name;
            b.classList.toggle('on', on); b.setAttribute('aria-selected', String(on));
            b.hidden = wide && tab === 'check';
        });
        root.querySelectorAll('[data-pane]').forEach(function (p) {
            var pane = p.getAttribute('data-pane');
            p.hidden = !(pane === name || (wide && pane === 'check'));
        });
        if (name === 'labels') { Lb.fontsReady().then(paintLabelsNow); paintLabelsNow(); }
        if (name === 'texts') paintTexts();
        return name;
    }
    function showTab(name) {
        curTab = name;
        stage('tab_' + applyTabs());
    }
    function watchWide() {
        var sync = function () {
            var wide = root.getBoundingClientRect().width >= 1480;
            if (wide === root.classList.contains('es-wide')) return;
            root.classList.toggle('es-wide', wide);
            applyTabs();
            if (wide) ae('wide', { w: Math.round(root.getBoundingClientRect().width / 10) * 10 });
        };
        sync();
        if (window.ResizeObserver) new ResizeObserver(sync).observe(root);
    }

    /* ── drafts («My products») ──────────────────────────────────────────── */
    function draftsBoot() {
        if (!window.__toolDraft || !window.__toolDraft.editor || !$('esDrafts')) return;
        drafts = window.__toolDraft.editor({
            slug: SLUG, root: 'esDrafts', icon: '🏷️',
            payload: function () {
                return { state: JSON.parse(JSON.stringify(card)), label: card.name || card.type || '', meta: { cat: card.category } };
            },
            apply: function (d) {
                var st = d && d.state;
                card = Object.assign(blankCard(), st || {});
                ['mfr', 'rp', 'textile', 'toy', 'battery', 'cosmetics', 'clp', 'packaging', 'epr', 'ce', 'label', 'usbc'].forEach(function (k) {
                    card[k] = Object.assign(blankCard()[k], (st || {})[k] || {});
                });
                paintFields(); render();
                return Promise.resolve([]);
            },
            fresh: function () { card = blankCard(); paintFields(); render(); },
            started: function () { return !!(card.name || card.category || card.markets.length || card.mfr.name); },
        });
        drafts.boot();
    }

    /* A filled card to show what the tool does on the first visit: a cotton
       T-shirt from a UK workshop sold to DE/FR/IT/ES through an EU representative.
       Addresses are example.* — nothing here can be mistaken for a real firm. */
    function exampleCard() {
        var c = blankCard();
        c.name = 'Organic cotton T-shirt'; c.category = 'textile'; c.type = 'TS-ORG-01'; c.batch = '2026-10';
        c.markets = ['de', 'fr', 'it', 'es'];
        c.mfr = { name: 'Example Studio Ltd', address: '12 Mill Lane, Leeds LS1 4AB, United Kingdom', email: 'hello@studio.example', phone: '', country: 'outside' };
        c.rp = { role: 'authorised_representative', name: 'Example EU Rep GmbH', address: 'Hauptstraße 1, 10115 Berlin, Germany', email: 'gpsr@eurep.example' };
        c.textile = { fibres: [{ n: 5, pct: 95 }, { n: 43, pct: 5 }], animal: false };
        var a = { kind: 'box', code: 'PAP20' }, b = { kind: 'bag', code: 'LDPE' };
        partWords(a); partWords(b);
        c.packaging = { parts: [a, b], largestCm2: '600' };
        c.contact = 'safety@studio.example';
        return c;
    }

    /* ── wiring ──────────────────────────────────────────────────────────── */
    function wire() {
        bindFields();
        $('es-example').addEventListener('click', function () {
            card = exampleCard();
            paintFields(); changed(true);
            stage('example');
        });
        root.querySelectorAll('[data-cat]').forEach(function (b) {
            b.addEventListener('click', function () {
                card.category = b.getAttribute('data-cat');
                if (card.category === 'textile' && !card.textile.fibres.length) card.textile.fibres.push({ n: 5, pct: 100 });
                if (!card.packaging.parts.length) { var p = { kind: 'box', code: 'PAP20' }; partWords(p); card.packaging.parts.push(p); }
                paintFields(); changed(true);
                stage('category', { cat: card.category });
            });
        });
        root.querySelectorAll('[data-market]').forEach(function (b) {
            b.addEventListener('click', function () {
                var m = b.getAttribute('data-market');
                var i = card.markets.indexOf(m);
                if (i >= 0) card.markets.splice(i, 1); else card.markets.push(m);
                paintMarkets(); changed(true);
            });
        });
        root.querySelectorAll('[data-preset]').forEach(function (b) {
            b.addEventListener('click', function () {
                var p = b.getAttribute('data-preset');
                card.markets = p === 'none' ? [] : (R.PRESETS[p] || []).slice();
                paintMarkets(); changed(true);
                ae('preset', { p: p });
            });
        });
        root.querySelectorAll('[data-toy-point]').forEach(function (cb) {
            cb.addEventListener('change', function () {
                card.toy.warnings = Array.prototype.slice.call(root.querySelectorAll('[data-toy-point]:checked')).map(function (x) { return +x.getAttribute('data-toy-point'); });
                changed(true);
            });
        });
        root.querySelectorAll('[data-picto]').forEach(function (cb) {
            cb.addEventListener('change', function () {
                card.clp.pictos = Array.prototype.slice.call(root.querySelectorAll('[data-picto]:checked')).map(function (x) { return x.getAttribute('data-picto'); });
                changed(true);
            });
        });
        $('es-fibre-add').addEventListener('click', function () { card.textile.fibres.push({ n: 35, pct: 0 }); paintFibres(); changed(true); });
        $('es-part-add').addEventListener('click', function () { var p = { kind: 'bag', code: 'LDPE' }; partWords(p); card.packaging.parts.push(p); paintParts(); changed(true); });
        root.querySelectorAll('[data-tab]').forEach(function (b) { b.addEventListener('click', function () { showTab(b.getAttribute('data-tab')); }); });
        $('es-kind').addEventListener('click', function (e) {
            var b = e.target.closest('[data-kind]'); if (!b) return;
            card.label.kind = b.getAttribute('data-kind');
            card.label.fmt = '';
            ae('label_kind', { kind: card.label.kind });
            $('es-kind').querySelectorAll('[data-kind]').forEach(function (x) { var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-pressed', String(on)); });
            changed(true);
        });
        $('es-format').addEventListener('change', function () { card.label.fmt = $('es-format').value; changed(true); ae('format', { fmt: card.label.fmt }); });
        $('es-copies').addEventListener('input', function () { card.label.copies = $('es-copies').value; });
        $('es-caption').addEventListener('change', function () { card.label.caption = $('es-caption').value; changed(true); });
        ['es-roll-w', 'es-roll-h'].forEach(function (id) {
            $(id).addEventListener('input', function () {
                card.label.roll = { w: parseFloat($('es-roll-w').value) || 58, h: parseFloat($('es-roll-h').value) || 40 };
                changed(false);
            });
        });
        $('es-langs').addEventListener('click', function (e) {
            var b = e.target.closest('[data-lang]'); if (!b) return;
            var ev = R.evaluate(card, today());
            var L = labelLangs(ev);
            var l = b.getAttribute('data-lang');
            var on = L.on.slice();
            var i = on.indexOf(l);
            if (i >= 0) on.splice(i, 1); else on.push(l);
            card.label.langs = L.auto.filter(function (x) { return on.indexOf(x) >= 0; });
            changed(true);
        });
        $('es-verdicts').addEventListener('click', function (e) {
            var b = e.target.closest('[data-use-format]'); if (!b) return;
            card.label.fmt = b.getAttribute('data-use-format');
            changed(true);
            ae('fit_fix', { fmt: card.label.fmt });
        });
        $('es-check').addEventListener('click', function (e) {
            var b = e.target.closest('[data-goto]'); if (b) { gotoField(b.getAttribute('data-goto')); ae('goto', { f: b.getAttribute('data-goto') }); }
        });
        $('es-texts').addEventListener('click', function (e) {
            var b = e.target.closest('[data-copy]'); if (b) copyText(+b.getAttribute('data-copy'));
        });
        $('es-pdf').addEventListener('click', exportOne);
        $('es-check-copy').addEventListener('click', function () {
            var txt = checklistText();
            if (!txt) { if (window.__toast) window.__toast(t('no_items'), 'warning'); return; }
            var done = function (ok) { if (window.__toast) window.__toast(ok ? (I.tx_copied || 'Copied') : (I.export_fail || '—'), ok ? 'success' : 'error'); if (ok) ae('copy_check', { n: R.evaluate(card, today()).items.length }); };
            if (window.__copyText) window.__copyText(txt).then(done, function () { done(false); });
            else if (navigator.clipboard) navigator.clipboard.writeText(txt).then(function () { done(true); }, function () { done(false); });
            else done(false);
        });
        $('es-live').addEventListener('click', function () {
            var a = $('es-answer-panel');
            if (a) a.scrollIntoView({ block: 'nearest' });
        });
        $('es-test').addEventListener('click', exportTest);
        $('es-svg').addEventListener('click', exportSvg);
        $('es-csv-go').addEventListener('click', exportCsv);
        $('es-csv-title').textContent = t('csv_title');
        $('es-csv-hint').textContent = t('csv_hint');
        $('es-csv-go-l').textContent = t('csv_go');
        var zone = $('es-csv-file');
        if (zone) {
            if (typeof window.__bindUploaderFile === 'function') window.__bindUploaderFile(zone, function (f) { if (f) onCsvFile(f); });
            else zone.addEventListener('tool-uploader:file', function (e) { var f = e.detail && e.detail.file; if (f) onCsvFile(f); });
        }
    }

    function boot() {
        R = window.EuRules; C = window.EuCompose; S = window.EuSymbols; Lb = window.EuLabels;
        if (!R || !C || !S || !Lb || !window.LabelLayout) return;
        C.use({ R: R, S: S, L: window.LabelLayout });
        wire();
        paintFields();
        render();
        draftsBoot();
        watchWide();
        stage('open');
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
})();
